import styled from 'styled-components';
import { spacing } from '@chegg-ui/theme';
export var QrDialogContainerSC = styled.div.withConfig({
  componentId: "sc-ma6khi-0"
})(["display:flex;align-items:center;flex-direction:column;gap:", ";justify-content:center;svg{margin:", " 0 ", " 0;}"], spacing.px16, spacing.px8, spacing.px16);